import { datadogRum } from "@datadog/browser-rum";
import { datadogLogs } from "@datadog/browser-logs";

export function isDatadogEnabled() {
  const isLocalhost = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
  const isDevelopment = process.env.NODE_ENV === "development";
  return !isDevelopment && !isLocalhost && !!process.env.REACT_APP_DATADOG_APPLICATION_ID;
}

// Report a handled error instead of swallowing it; console only where Datadog is off.
export function reportError(error, context = {}) {
  if (isDatadogEnabled()) {
    datadogRum.addError(error, context);
  } else {
    // eslint-disable-next-line no-console
    console.error(error, context);
  }
}

/**
 * Logs a failed API request when it is the API's fault: a 5xx or no answer at
 * all. A 4xx is the API answering (401 expired session, 422 bad input) and the
 * caller already handles it, so it is not an error here.
 */
export function reportApiFailure(error) {
  if (!isDatadogEnabled()) return;
  const status = error?.response?.status;
  if (status !== undefined && status < 500) return;
  datadogLogs.logger.error("API request failed", {
    url: error?.config?.url,
    method: error?.config?.method,
    status,
    error_message: error?.message
  });
}

export function setDatadogGlobalContext(context) {
  if (!isDatadogEnabled()) return;
  const entries = Object.entries(context).filter(([, value]) => value != null && value !== "");
  entries.forEach(([key, value]) => datadogRum.setGlobalContextProperty(key, value));
  entries.forEach(([key, value]) => datadogLogs.setGlobalContextProperty(key, value));
}
